import classNames from "classnames";
import filesize from "filesize";
import { useField, useFormikContext } from "formik";
import React from "react";
import { renderErrorMessage } from "./Tools";

export function FileInput(props: {
  fieldName: string;
  validFileTypes?: string;
  filename?: string;
  maxSizeBytes?: number;
}) {
  const { setFieldValue, setFieldTouched, setFieldError } = useFormikContext<
    any
  >();
  const validate = (value: File | null) => {
    if (value && props.maxSizeBytes && value.size > props.maxSizeBytes) {
      return `This file exceeds the allowed limit. Please select a file that is no greater than ${filesize(
        props.maxSizeBytes,
      )}.`;
    }
  };
  const [field, meta] = useField({
    name: props.fieldName,
    // NOTE: any here because FieldValidator has the wrong type
    // watch for release of https://github.com/jaredpalmer/formik/pull/1680
    validate: validate as any,
  });
  const filename = field.value ? field.value.name : props.filename;
  return (
    <>
      <div className={classNames("file", { "has-name": filename })}>
        <label className="file-label">
          <input
            className="file-input"
            type="file"
            id={props.fieldName}
            name={props.fieldName}
            accept={props.validFileTypes}
            onChange={e => {
              setFieldTouched(props.fieldName, true, false);
              const file = e.target.files && e.target.files[0];
              const error = validate(file);
              if (error) {
                setFieldError(props.fieldName, error);
                e.target.value = "";
              } else {
                setFieldValue(props.fieldName, file);
              }
            }}
          />
          <span className="file-cta">
            <span className="file-icon">
              <i className="fa fa-upload" />
            </span>
            <span className="file-label">Choose a file…</span>
          </span>
          {filename && <span className="file-name">{filename}</span>}
        </label>
      </div>
      {renderErrorMessage(meta)}
    </>
  );
}
